import Button from "@common/Button";

const MODE_ICONS = { Remote: "fa-wifi", Hybrid: "fa-building-user", "On-site": "fa-building" };

export default function JobCard({ job, onViewDetails }) {
  const statusCls = `fc-status-${(job.status || "open").toLowerCase()}`;

  return (
    <div className="fc-job-card fc-card-hover">
      <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
        <div className="flex-grow-1 overflow-hidden">
          <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
            <span className="fc-job-title">{job.title}</span>
            {job.urgent && <span className="fc-badge-urgent">URGENT</span>}
            <span className={`badge rounded-pill ${statusCls}`} style={{ fontSize: 10, fontWeight: 600 }}>
              <span className="fc-status-dot" />{job.status}
            </span>
          </div>
          <div className="fc-job-company">{job.company}</div>
          <div className="d-flex flex-wrap gap-2 fc-job-meta mt-1">
            <span><i className="fa-solid fa-location-dot fc-job-meta-icon" />{job.location}</span>
            <span><i className="fa-solid fa-briefcase fc-job-meta-icon" />{job.type}</span>
            <span className="d-none d-sm-inline"><i className={`fa-solid ${MODE_ICONS[job.mode] || "fa-building"} fc-job-meta-icon`} />{job.mode}</span>
            <span className="d-none d-md-inline"><i className="fa-solid fa-clock fc-job-meta-icon" />{job.posted}</span>
            <span className="d-none d-md-inline"><i className="fa-solid fa-users fc-job-meta-icon" />{job.applicants} applicants</span>
          </div>
        </div>

        {/* Salary + View Details stacked on right */}
        <div className="flex-shrink-0 text-end d-flex flex-column align-items-end gap-2">
          <div>
            <div className="fc-job-salary">{job.salary}</div>
            <div className="fc-job-salary-unit">/mo</div>
          </div>
          <Button variant="primary" size="sm" pill icon="fa-eye"
            onClick={() => onViewDetails && onViewDetails(job)}>
            View Details
          </Button>
        </div>
      </div>

      <div className="d-flex flex-wrap gap-1">
        {(job.skills || []).slice(0, 5).map(s => <span key={s} className="fc-skill">{s}</span>)}
        {(job.skills || []).length > 5 && <span className="fc-tag" style={{ fontSize: 10, padding: "2px 7px" }}>+{job.skills.length - 5}</span>}
      </div>
    </div>
  );
}
